import { object } from "yup"
import kycModel from "../atoms/kyc.model"
import licenceModel from "../atoms/licence.model"
import { firstName, ID, lastName, phoneNumber } from "../yup.common"
export default object({
  id: ID,
  vehicleId: ID,
  firstName: firstName.required(),
  lastName: lastName.required(),
  number: phoneNumber.required(),
  secondaryNumber: phoneNumber.transform(v => (v === "" ? null : v)).nullable(),
  licenceDetail: licenceModel,
  kycDetail: kycModel,
})
